// TODO: Move facility maps to authenticated API/S3-backed storage if maps are considered sensitive or need admin upload/versioning.

export interface FacilityMapFile {
  /** Display label for this map (e.g. "Main Office Map") */
  label: string;
  /** URL-safe path to the PDF under /facility-maps/ */
  pdfUrl: string;
}

export interface FacilityMapDefinition {
  locationName: string;
  normalizedLocationName: string;
  title: string;
  maps: FacilityMapFile[];
}

/**
 * Registry of all locations that have facility map PDFs.
 * Only locations with at least one PDF are included.
 * Locations whose folders exist but have no PDFs yet are omitted.
 */
export const facilityMapRegistry: FacilityMapDefinition[] = [
  {
    locationName: "Atlanta",
    normalizedLocationName: "atlanta",
    title: "Atlanta Evacuation Map",
    maps: [
      { label: "Atlanta Map", pdfUrl: "/facility-maps/atlanta/atlanta-map.pdf" },
    ],
  },
  {
    locationName: "Bellevue",
    normalizedLocationName: "bellevue",
    title: "Bellevue Evacuation Map",
    maps: [
      { label: "Bellevue Map", pdfUrl: "/facility-maps/bellevue/bellevue-map.pdf" },
    ],
  },
  {
    locationName: "Bowie",
    normalizedLocationName: "bowie",
    title: "Bowie Evacuation Map",
    maps: [
      { label: "Bowie Map", pdfUrl: "/facility-maps/bowie/bowie-map.pdf" },
    ],
  },
  {
    locationName: "Chicago",
    normalizedLocationName: "chicago",
    title: "Chicago Evacuation Map",
    maps: [
      { label: "Chicago Map", pdfUrl: "/facility-maps/chicago/chicago-map.pdf" },
    ],
  },
  {
    locationName: "Denver",
    normalizedLocationName: "denver",
    title: "Denver Evacuation Map",
    maps: [
      { label: "Denver Map", pdfUrl: "/facility-maps/denver/denver-map.pdf" },
    ],
  },
  {
    locationName: "Detroit",
    normalizedLocationName: "detroit",
    title: "Detroit Evacuation Map",
    maps: [
      { label: "Detroit Map", pdfUrl: "/facility-maps/detroit/detroit-map.pdf" },
    ],
  },
  {
    locationName: "Farmington Hills",
    normalizedLocationName: "farmington hills",
    title: "Farmington Hills Evacuation Map",
    maps: [
      { label: "Farmington Hills Map", pdfUrl: "/facility-maps/detroit/detroit-map.pdf" },
    ],
  },
  {
    locationName: "Los Angeles",
    normalizedLocationName: "los angeles",
    title: "Los Angeles Evacuation Map",
    maps: [
      { label: "Los Angeles Map", pdfUrl: "/facility-maps/los-angeles/los-angeles-map.pdf" },
    ],
  },
  {
    locationName: "Menlo Park",
    normalizedLocationName: "menlo park",
    title: "Menlo Park Evacuation Map",
    maps: [
      { label: "Menlo Park Map", pdfUrl: "/facility-maps/menlo-park/menlo-park-map.pdf" },
    ],
  },
  {
    locationName: "Miami",
    normalizedLocationName: "miami",
    title: "Miami Evacuation Map",
    maps: [
      { label: "Miami Map", pdfUrl: "/facility-maps/miami/miami-map.pdf" },
    ],
  },
  {
    locationName: "Natick",
    normalizedLocationName: "natick",
    title: "Natick Evacuation Map",
    maps: [
      { label: "Natick Map", pdfUrl: "/facility-maps/natick/natick-map.pdf" },
    ],
  },
  {
    locationName: "New York",
    normalizedLocationName: "new york",
    title: "New York Evacuation Map",
    maps: [
      { label: "New York Map", pdfUrl: "/facility-maps/new-york/new-york-map.pdf" },
    ],
  },
  {
    locationName: "Oakland",
    normalizedLocationName: "oakland",
    title: "Oakland Evacuation Map",
    maps: [
      { label: "Oakland Map", pdfUrl: "/facility-maps/oakland/oakland-map.pdf" },
    ],
  },
  {
    locationName: "Orange County",
    normalizedLocationName: "orange county",
    title: "Orange County Evacuation Map",
    maps: [
      { label: "Orange County Map", pdfUrl: "/facility-maps/orange-county/orange-county-map.pdf" },
    ],
  },
  {
    locationName: "Philadelphia",
    normalizedLocationName: "philadelphia",
    title: "Philadelphia Evacuation Map",
    maps: [
      { label: "Philadelphia Map", pdfUrl: "/facility-maps/philadelphia/philadelphia-map.pdf" },
    ],
  },
  {
    locationName: "Phoenix",
    normalizedLocationName: "phoenix",
    title: "Phoenix Evacuation Map",
    maps: [
      { label: "Phoenix Map", pdfUrl: "/facility-maps/phoenix/phoenix-map.pdf" },
    ],
  },
  {
    locationName: "Seattle",
    normalizedLocationName: "seattle",
    title: "Seattle Evacuation Maps",
    maps: [
      { label: "Seattle Map", pdfUrl: "/facility-maps/seattle/seattle-map.pdf" },
      { label: "Warehouse Emergency Plan", pdfUrl: "/facility-maps/seattle/seattle-warehouse-emergency-plan-2025.pdf" },
    ],
  },
  {
    locationName: "Virginia",
    normalizedLocationName: "virginia",
    title: "Virginia Evacuation Map",
    maps: [
      { label: "Virginia Map", pdfUrl: "/facility-maps/virginia/virginia-map.pdf" },
    ],
  },
  {
    locationName: "Warrenville",
    normalizedLocationName: "warrenville",
    title: "Warrenville Evacuation Map",
    maps: [
      { label: "Warrenville Map", pdfUrl: "/facility-maps/warrenville/warrenville-map.pdf" },
    ],
  },
  {
    locationName: "Washington D.C.",
    normalizedLocationName: "washington d.c.",
    title: "Washington D.C. Evacuation Map",
    maps: [
      { label: "Washington D.C. Map", pdfUrl: "/facility-maps/washington-dc/washington-dc-map.pdf" },
    ],
  },
];

export function normalizeLocationName(value?: string | null): string {
  return (value ?? "").trim().replace(/\s+/g, " ").toLowerCase();
}

export function getFacilityMapForLocation(locationName?: string | null): FacilityMapDefinition | null {
  const normalized = normalizeLocationName(locationName);
  return facilityMapRegistry.find(m => m.normalizedLocationName === normalized) ?? null;
}
